import { useQuery } from '@tanstack/react-query';
import { ComponentProps } from 'react';
import { QueryApi } from '@/features/query/api';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const CurrentVenueName = ({ media, ...props }: Props) => {
    const venueQuery = useQuery(QueryApi.Venue.queries.Venue);

    return (
        <Layout
            element="span"
            media={{ ...media, initial: { fontSize: '1.25rem', fontWeight: 600, ...media?.initial } }}
            data-testid="current-venue-name"
            {...props}
        >
            {venueQuery.data?.name}
        </Layout>
    );
};
